module.exports = __webpack_public_path__ + "img/multiplier.2b4fd592.png";